import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import BottomNavigation from './components/layout/BottomNavigation';
import HomePage from './pages/HomePage';
import DiscoverPage from './pages/DiscoverPage';
import CreatePostPage from './pages/CreatePostPage';
import NotificationsPage from './pages/NotificationsPage';
import ProfilePage from './pages/ProfilePage';
import SignupPage from './pages/SignupPage';
import ChatPage from './pages/ChatPage';
export function App() {
  return <BrowserRouter data-id="element-0">
      <div className="app-container" data-id="element-1">
        <div className="app-frame" data-id="element-2">
          <div className="app-content" data-id="element-3">
            <Routes data-id="element-4">
              <Route path="/" element={<HomePage data-id="element-6" />} data-id="element-5" />
              <Route path="/discover" element={<DiscoverPage data-id="element-8" />} data-id="element-7" />
              <Route path="/create" element={<CreatePostPage data-id="element-10" />} data-id="element-9" />
              <Route path="/notifications" element={<NotificationsPage data-id="element-12" />} data-id="element-11" />
              <Route path="/profile" element={<ProfilePage data-id="element-14" />} data-id="element-13" />
              <Route path="/signup" element={<SignupPage data-id="element-16" />} data-id="element-15" />
              <Route path="/chat" element={<ChatPage data-id="element-18" />} data-id="element-17" />
            </Routes>
          </div>
          <BottomNavigation data-id="element-19" />
        </div>
      </div>
    </BrowserRouter>;
}